import { render, staticRenderFns } from "./Synchronize.vue?vue&type=template&id=62d8b56a&scoped=true"
import script from "./Synchronize.vue?vue&type=script&lang=js"
export * from "./Synchronize.vue?vue&type=script&lang=js"
import style0 from "./Synchronize.vue?vue&type=style&index=0&id=62d8b56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d8b56a",
  null
  
)

export default component.exports